(() => {
  /* ============================================================
     LIVE GANGSHEET PRICING — PrintOtex
     ------------------------------------------------------------
     Affiche en direct sur la page produit DTF le prix unitaire,
     le total et le % de remise selon la quantité choisie.

     LES PALIERS (TIERS) peuvent être configurés SANS CODE via la
     section "Paliers de tarification DTF (live)" du theme editor.
     Si aucune config n'est trouvée, on retombe sur les DEFAULT_TIERS
     ci-dessous pour ne rien casser.

     ⚠️  Cet affichage NE modifie PAS les vraies remises appliquées
        au checkout : celles-ci sont gérées via
        Admin → Réductions → GemPages Bundle Discount.
     ============================================================ */

  // ---- Fallback safe si la section de config n'est pas ajoutée ----
  const DEFAULT_TIERS = [
    { min: 100, rate: 0.75 }, // 100+ pièces → -75%
    { min: 50,  rate: 0.60 }, // 50-99      → -60%
    { min: 20,  rate: 0.50 }, // 20-49      → -50%
    { min: 10,  rate: 0.40 }, // 10-19      → -40%
    { min: 5,   rate: 0.30 }, // 5-9        → -30%
  ];

  function resolveTiers() {
    try {
      const cfg = window.LIVE_TIER_PRICING_CONFIG && window.LIVE_TIER_PRICING_CONFIG.tiers;
      if (Array.isArray(cfg) && cfg.length > 0) {
        const valid = cfg
          .filter(t =>
            t &&
            Number.isFinite(Number(t.min)) &&
            Number.isFinite(Number(t.rate)) &&
            Number(t.min) > 0 &&
            Number(t.rate) >= 0 &&
            Number(t.rate) <= 1
          )
          .map(t => ({ min: Number(t.min), rate: Number(t.rate) }))
          // ordre décroissant par min pour que getRate() prenne le plus haut d'abord
          .sort((a, b) => b.min - a.min);
        if (valid.length > 0) return valid;
      }
    } catch (_) { /* ignore, fallback */ }
    return DEFAULT_TIERS;
  }

  const TIERS = resolveTiers();

  /* ============================================================
     GRILLE MÈTRES (format 1m — 100×57 cm)
     ------------------------------------------------------------
     Le format Mètres a une grille de prix custom (non-linéaire)
     fournie par le fournisseur. Elle ne peut pas être modélisée
     avec des paliers en %, donc on la gère à part.

     Détection : quand le prix de base du variant sélectionné est
     dans la fourchette [MÈTRES_BASE_MIN, MÈTRES_BASE_MAX], on
     bascule sur cette grille au lieu des TIERS.

     Comportement pour une qty non listée (ex : 22) → on prend le
     palier immédiatement INFÉRIEUR (donc 22 = prix de 20).
     Pour qty > 100 → on garde le prix de 100.

     ⚠️  Si le fournisseur change ces tarifs, il faudra mettre à
        jour cette table côté code (contact dev).
     ============================================================ */
  const METRES_BASE_MIN = 14.0;
  const METRES_BASE_MAX = 17.0;
  const METRES_GRID = [
    { qty: 1,   price: 15.20 },
    { qty: 2,   price: 14.78 },
    { qty: 3,   price: 14.34 },
    { qty: 4,   price: 14.03 },
    { qty: 5,   price: 13.87 },
    { qty: 6,   price: 13.69 },
    { qty: 7,   price: 13.51 },
    { qty: 8,   price: 13.05 },
    { qty: 9,   price: 12.65 },
    { qty: 10,  price: 12.50 },
    { qty: 11,  price: 12.47 },
    { qty: 12,  price: 12.37 },
    { qty: 13,  price: 12.27 },
    { qty: 14,  price: 12.09 },
    { qty: 15,  price: 11.89 },
    { qty: 16,  price: 11.60 },
    { qty: 17,  price: 11.48 },
    { qty: 18,  price: 11.38 },
    { qty: 19,  price: 11.23 },
    { qty: 20,  price: 10.91 },
    { qty: 25,  price: 10.39 },
    { qty: 30,  price: 10.29 },
    { qty: 35,  price: 9.90  },
    { qty: 40,  price: 9.69  },
    { qty: 45,  price: 9.34  },
    { qty: 50,  price: 8.97  },
    { qty: 60,  price: 8.44  },
    { qty: 70,  price: 8.25  },
    { qty: 80,  price: 8.10  },
    { qty: 90,  price: 8.06  },
    { qty: 100, price: 7.65  },
  ].sort((a, b) => a.qty - b.qty);

  function isMetresBase(base) {
    return Number.isFinite(base) && base >= METRES_BASE_MIN && base <= METRES_BASE_MAX;
  }

  function getMetresUnitPrice(qty) {
    // Prend le palier immédiatement inférieur ou égal
    let match = METRES_GRID[0].price;
    for (const t of METRES_GRID) {
      if (t.qty <= qty) match = t.price;
      else break;
    }
    return match;
  }

  function getMetresNextTier(qty) {
    // Prochain palier strictement supérieur (pour le hint)
    for (const t of METRES_GRID) {
      if (t.qty > qty) return t;
    }
    return null;
  }

  const SELECTORS = {
    addToCartBtn: 'button.product-form__submit',
    anchor: '.product-form__buttons',
    qtyInput: '.quantity__input',
    priceEl: '.price-item--regular, .price__regular .price-item, [data-price]',
  };
  const DTF_HANDLE_FALLBACK = 'transfert-dtf-personnalise';
  const euroRegex = /(\d+(?:[.,]\d{1,2})?)\s*€?/;

  function parseEuro(text) {
    if (!text) return NaN;
    const m = String(text).replace(/\s/g, '').match(euroRegex);
    return m ? parseFloat(m[1].replace(',', '.')) : NaN;
  }
  function formatEuro(n) {
    return isFinite(n) ? n.toFixed(2).replace('.', ',') + '€' : '';
  }
  function getRate(qty) {
    for (const t of TIERS) if (qty >= t.min) return t.rate;
    return 0;
  }
  function getNextTier(qty) {
    return [...TIERS].sort((a, b) => a.min - b.min).find(t => qty < t.min) || null;
  }
  function getProductHandle() {
    try {
      return window.ShopifyAnalytics?.meta?.product?.handle
          || document.body?.dataset?.productHandle
          || DTF_HANDLE_FALLBACK;
    } catch {
      return document.body?.dataset?.productHandle || DTF_HANDLE_FALLBACK;
    }
  }
  function getProductForm() {
    return document.querySelector(SELECTORS.addToCartBtn)?.closest('form[action^="/cart/add"]')
        || document.querySelector('form[action^="/cart/add"]');
  }
  function getVariantIdValue(form) {
    const idInput = form?.querySelector('[name="id"]');
    return idInput?.value ? String(idInput.value) : '';
  }
  function getProductRoot(form) {
    return form?.closest('section, .product, .product__info, main') || document;
  }
  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return await res.json();
  }
  async function getQtyInCartForHandle(handle) {
    try {
      const cart = await fetchCart();
      let sum = 0;
      for (const item of cart.items || []) {
        const h = item.handle || (item.url ? item.url.split('/products/')[1]?.split('?')[0] : '');
        if (h === handle) sum += item.quantity || 0;
      }
      return sum;
    } catch {
      return 0;
    }
  }
  function ensureUI(anchor) {
    let wrap = document.querySelector('.live-tier-pricing');
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'live-tier-pricing';
    wrap.innerHTML = `
      <div class="ltp-title">
        <img class="ltp-icon"
          src="https://cdn.shopify.com/s/files/1/0995/8847/3157/files/tarif-printotex.svg?v=1765791324"
          alt="" aria-hidden="true" loading="lazy" />
        <span class="ltp-title-text">Tarification dégressive selon la quantité</span>
      </div>

      <div class="ltp-grid">
        <div class="ltp-card">
          <div class="ltp-label">Prix unitaire</div>
          <div class="ltp-row">
            <div class="ltp-value" data-unit>—</div>
            <div class="ltp-badge" data-badge hidden>—</div>
          </div>
          <div class="ltp-sub" data-incart style="margin-top:8px; font-size:12px; opacity:.7"></div>
        </div>

        <div class="ltp-card">
          <div class="ltp-label">Total commande</div>
          <div class="ltp-row">
            <div class="ltp-value" data-total>—</div>
            <div class="ltp-pill" data-save hidden>Économie : —</div>
          </div>
        </div>
      </div>

      <div class="ltp-hint" data-hint></div>
    `;
    anchor.parentNode.insertBefore(wrap, anchor);
    return wrap;
  }
  function readQtySelected(form) {
    const input = form?.querySelector(SELECTORS.qtyInput);
    if (!input) return 1;
    const qty = parseInt(input.value || '1', 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }
  function readBaseUnitPrice(form) {
    const priceEl = getProductRoot(form).querySelector(SELECTORS.priceEl);
    return priceEl ? parseEuro(priceEl.textContent || '') : NaN;
  }

  let lastCartQty = 0;
  let updating = false;

  async function update() {
    const form = getProductForm();
    const anchor = document.querySelector(SELECTORS.anchor);
    if (!form || !anchor) return;
    const ui = ensureUI(anchor);
    const baseUnit = readBaseUnitPrice(form);
    if (!isFinite(baseUnit)) return;
    const handle = getProductHandle();
    const inCart = await getQtyInCartForHandle(handle);
    lastCartQty = inCart;
    const selected = readQtySelected(form);

    // --- Branchement Métres vs Planches ---
    const metresMode = isMetresBase(baseUnit);

    let unitAfter, rate;
    if (metresMode) {
      unitAfter = getMetresUnitPrice(selected);
      rate = baseUnit > 0 ? Math.max(0, 1 - unitAfter / baseUnit) : 0;
    } else {
      rate = getRate(selected);
      unitAfter = baseUnit * (1 - rate);
    }
    const totalAfter = unitAfter * selected;
    const save = baseUnit * selected - totalAfter;

    ui.querySelector('[data-unit]').textContent = formatEuro(unitAfter);
    ui.querySelector('[data-total]').textContent = formatEuro(totalAfter);

    const badge = ui.querySelector('[data-badge]');
    if (rate > 0.005) {
      badge.hidden = false;
      badge.textContent = `-${Math.round(rate * 100)}%`;
    } else {
      badge.hidden = true;
    }

    const pill = ui.querySelector('[data-save]');
    if (save > 0.01) {
      pill.hidden = false;
      pill.textContent = `Économie : ${formatEuro(save)}`;
    } else {
      pill.hidden = true;
    }

    const incart = ui.querySelector('[data-incart]');
    incart.textContent = inCart > 0 ? `Déjà dans le panier : ${inCart}` : '';

    const hint = ui.querySelector('[data-hint]');
    if (metresMode) {
      const nextM = getMetresNextTier(selected);
      if (nextM) {
        const remaining = nextM.qty - selected;
        hint.textContent = `Plus que ${remaining} mètre${remaining > 1 ? 's' : ''} pour passer à ${formatEuro(nextM.price)}/m`;
      } else {
        hint.textContent = 'Meilleur tarif au mètre appliqué';
      }
    } else {
      const next = getNextTier(selected);
      if (next) {
        const remaining = next.min - selected;
        hint.textContent = `Plus que ${remaining} pièce${remaining > 1 ? 's' : ''} pour obtenir ${Math.round(next.rate * 100)}% de réduction`;
      } else if (rate > 0) {
        hint.textContent = 'Réduction maximale appliquée';
      } else {
        hint.textContent = '';
      }
    }
  }

  async function safeUpdate() {
    if (updating) return;
    updating = true;
    try { await update(); } finally { updating = false; }
  }

  let syncTimer = null;
  let lastSeenVariant = '';
  let lastSeenPrice = '';

  function startSyncLoop(durationMs = 900) {
    if (syncTimer) clearInterval(syncTimer);
    const form = getProductForm();
    if (!form) return;
    const root = getProductRoot(form);
    const startedAt = Date.now();
    syncTimer = setInterval(() => {
      const v = getVariantIdValue(form);
      const p = (root.querySelector(SELECTORS.priceEl)?.textContent || '').trim();
      if ((v && v !== lastSeenVariant) || (p && p !== lastSeenPrice)) {
        lastSeenVariant = v || lastSeenVariant;
        lastSeenPrice = p || lastSeenPrice;
        safeUpdate();
      }
      if (Date.now() - startedAt > durationMs) {
        clearInterval(syncTimer);
        syncTimer = null;
        safeUpdate();
      }
    }, 60);
  }

  function resetQtyToOne() {
    const form = getProductForm();
    if (!form) return;
    const qtyInput = form.querySelector(SELECTORS.qtyInput);
    if (!qtyInput) return;
    const qtyWrap = qtyInput.closest('quantity-input') || qtyInput.closest('.quantity') || qtyInput.parentElement;
    const minusBtn = qtyWrap?.querySelector('button[name="minus"]')
                  || qtyWrap?.querySelector('button.quantity__button[name="minus"]')
                  || qtyWrap?.querySelector('button[aria-label*="moins"]')
                  || qtyWrap?.querySelector('button[aria-label*="minus"]');
    let current = parseInt(qtyInput.value || '1', 10);
    if (!Number.isFinite(current) || current < 1) current = 1;
    if (minusBtn && current > 1) {
      for (let i = 0; i < current - 1; i++) minusBtn.click();
      return;
    }
    qtyInput.value = '1';
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function installAddToCartHook() {
    if (window.__dtfFetchHookInstalled) return;
    window.__dtfFetchHookInstalled = true;
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const res = await originalFetch.apply(this, args);
      try {
        const url = String(args?.[0] || '');
        if ((url.includes('/cart/add') || url.includes('/cart/add.js')) && res && res.ok) {
          setTimeout(() => {
            resetQtyToOne();
            startSyncLoop(900);
            safeUpdate();
          }, 250);
        }
      } catch {}
      return res;
    };
  }

  function boot() {
    const form = getProductForm();
    if (form) {
      const root = getProductRoot(form);
      lastSeenVariant = getVariantIdValue(form);
      lastSeenPrice = (root.querySelector(SELECTORS.priceEl)?.textContent || '').trim();
    }
    installAddToCartHook();
    safeUpdate();
    document.addEventListener('click', (e) => {
      if (e.target.closest('form[action^="/cart/add"]') || e.target.closest('.product')) {
        startSyncLoop(900);
        safeUpdate();
      }
    });
    document.addEventListener('input', () => startSyncLoop(500));
    document.addEventListener('change', () => startSyncLoop(500));
    setInterval(async () => {
      const handle = getProductHandle();
      const q = await getQtyInCartForHandle(handle);
      if (q !== lastCartQty) safeUpdate();
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();